import React from 'react';
import {
    AUTH_REDIRECT_ROUTES,
    AUTH_ROUTES_PATH,
    ROUTES_PATH_CONFIG
} from '../../config/routes';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { loadGlobalState } from 'eebac/reducers/app';

function AuthCheck(props) {
    const history = useHistory();
    const location = useLocation();

    const {
        authData,
        children,
        loadGlobalState
    } = props

    let user = authData.user ? authData.user : { role: "none" };

    if (!authData.isSignedIn || !AUTH_REDIRECT_ROUTES.ROLES[user.role] ||
        !AUTH_ROUTES_PATH.PATHS[location.pathname] ||
        !AUTH_ROUTES_PATH.PATHS[location.pathname].includes(user.role)) {

        history.push(ROUTES_PATH_CONFIG.APP.signin);
        return null;
    } 
    
    loadGlobalState();


    return (children);
}

AuthCheck.defaultProps = {
    authData: {}
}

const mapStateToProps = state => ({
    authData: state.AUTH
});

const mapDispatchToProps = dispatch => ({
    loadGlobalState : () => dispatch(loadGlobalState())
});


export default connect(mapStateToProps, mapDispatchToProps)(AuthCheck);